function Spinner() {
    return (
       <div className="h-screen flex justify-center items-center">
            <span className="loading loading-spinner loading-lg text-primary"></span>
       </div>
    )
}

export default Spinner